import axiosInstance from '../../api';
import API_ENDPOINTS from '../../api/endpoints';
import useGeneralStore from '../../../Store/generalStore';
import { parseApiResponse, isSuccessResponse, getErrorMessage } from '../../api/responseModel';
import { notifyApiError } from '../../api/errorUtils';

const useInquiries = () => {
    const { setLoading, setMessage, setError } = useGeneralStore();

    const submitInquiry = async (formData, formType) => {
        try {
            setLoading(true);

            const payload = {
                firstName: formData.firstName || '',
                lastName: formData.lastName || '',
                email: formData.email || '',
                phone: formData.phone != null ? String(formData.phone) : '',
                message: formData.message || '',
                companyName: formData.companyName || '',
                website: formData.website || '',
                officeAddress: formData.officeAddress || '',
                formType,
            };

            const response = await axiosInstance.post(API_ENDPOINTS.INQUIRIES.ADD, payload);
            const apiResponse = parseApiResponse(response);

            if (isSuccessResponse(apiResponse)) {
                setMessage('Thank you! Your form has been submitted successfully.');
                return true;
            }

            const errorMsg = getErrorMessage(apiResponse) || 'Failed to submit form. Please try again.';
            setError(errorMsg);
            return false;
        } catch (error) {
            notifyApiError(setError, error, 'Failed to submit form. Please try again.');
            return false;
        } finally {
            setLoading(false);
        }
    };

    const subscribeNewsletter = async (emailAddress) => {
        try {
            setLoading(true);

            const response = await axiosInstance.post(
                API_ENDPOINTS.INQUIRIES.ADD_NEWSLETTER,
                null,
                {
                    params: { EmailAddress: emailAddress },
                }
            );
            const apiResponse = parseApiResponse(response);

            if (isSuccessResponse(apiResponse)) {
                setMessage(
                    apiResponse.responseMessage ||
                    'Successfully signed up to the newsletter!'
                );
                return true;
            }

            const errorMsg = getErrorMessage(apiResponse) || 'Failed to subscribe. Please try again.';
            setError(errorMsg);
            return false;
        } catch (error) {
            notifyApiError(setError, error, 'Failed to subscribe. Please try again.');
            return false;
        } finally {
            setLoading(false);
        }
    };

    return {
        submitInquiry,
        subscribeNewsletter,
    };
};

export default useInquiries;
